var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalPolice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "local_police"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1131_3149",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1131_3149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "local_police_2",
    d: "M6.1 10.3167L8 8.9167L9.86667 10.3167L9.1 8.03336L11 6.6667H8.70033L8 4.43336L7.29967 6.6667H5.01667L6.86667 8.03336L6.1 10.3167ZM7.999 15.0834C6.323 14.6633 4.94583 13.7054 3.8675 12.2099C2.78917 10.7143 2.25 9.07397 2.25 7.28886V3.0257L8 0.883362L13.7667 3.0262V7.28336C13.7667 9.06992 13.2243 10.7115 12.1397 12.2082C11.0551 13.7049 9.67489 14.6633 7.999 15.0834ZM8 13.4834C9.22222 13.0056 10.225 12.2056 11.0083 11.0834C11.7917 9.96114 12.1833 8.69608 12.1833 7.2882V4.13336L8 2.55003L3.81667 4.14136V7.28053C3.81667 8.69353 4.20833 9.96114 4.99167 11.0834C5.775 12.2056 6.77778 13.0056 8 13.4834Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalPolice);
export default __webpack_public_path__ + "static/media/local_police.1f6bfe12c3df4b27d490e2be7ec2c781.svg";
export { ForwardRef as ReactComponent };